export default __webpack_public_path__ + "0248f6d2d5415b1b62d04c57a3de4f9924ab6676/45b3d9bead8ca49501a2a3b80e7cc1ac.png";